import React from 'react';

import './index.css';

// horizontal divider

const HorizontalLine = () => <div className='horizontal_line'></div>;

export default HorizontalLine;
